// Copyright (c) Bentley Systems
export enum DeleteCredentialType {
  CloudSystem,
  OnPremise,
  OnPremiseSystem,
}
